import Link from 'next/link'
import Icon from 'ui/components/Icon'
import {
  Card,
  Info,
  Name,
  Position,
  AdditionalText,
  ServiceUserIcon,
  ServiceUserTooltip,
} from './styled'
import { AvatarSpecial } from '../AvatarSpecial'
import {
  USER_CARD_SMALL_MODE,
  LINK_MODES,
  SERVICE_USER_TOOLTIP_TITLE,
} from './constants'
import { getAdditionalText } from './helpers'

const UserCardSmall = ({
  mode = USER_CARD_SMALL_MODE.DEFAULT,
  as,
  href = null,
  handler,
  direction = 'horizontal',
  name = '',
  avatar,
  isApi,
  position = '',
  additionalText = '',
  style,
  isServiceUser = false,
}) => {
  const isLinkMode = LINK_MODES.includes(mode) && href
  const isModalMode = mode === USER_CARD_SMALL_MODE.MODAL
  const isUserListMode = mode === USER_CARD_SMALL_MODE.USER_LIST

  const shouldShowDetails = !isUserListMode
  const shouldShowServiceUserTooltip = isUserListMode && isServiceUser

  const preparedAdditionalText = getAdditionalText(additionalText, mode)

  const content = (
    <>
      <AvatarSpecial src={avatar} isApi={isApi} alt={name} />

      <Info>
        <Name>
          {name}
          {shouldShowServiceUserTooltip && (
            <ServiceUserTooltip
              title={SERVICE_USER_TOOLTIP_TITLE}
              arrow
              placement="top"
            >
              <ServiceUserIcon>
                <Icon name="settings" size="16" />
              </ServiceUserIcon>
            </ServiceUserTooltip>
          )}
        </Name>

        {shouldShowDetails && position && <Position>{position}</Position>}

        {shouldShowDetails && preparedAdditionalText && (
          <AdditionalText>{preparedAdditionalText}</AdditionalText>
        )}
      </Info>
    </>
  )

  return (
    <Card style={style} direction={direction}>
      {isLinkMode && (
        <Link href={href} as={as}>
          <a onClick={handler} target="_blank" rel="noopener noreferrer">
            {content}
          </a>
        </Link>
      )}

      {isModalMode && <a onClick={handler}>{content}</a>}
    </Card>
  )
}

export default UserCardSmall
